module.exports = __webpack_public_path__ + "static/media/ico_open.2bd46266.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contents/ico_open.png
// module id = 274
// module chunks = 0